export const menuDatavis = {
    menu: [
        {label: 'menu.OuvrirDossier', icon: '', url: '/accueil', children: []},
        {
            label: 'front.menuAdmin.group1',
            icon: 'person',
            children: [
                {
                    label: 'general.utilisateurs',
                    url: '/administration/utilisateurs',
                },
                {
                    label: 'general.mandatsUtilisateurs',
                    url: '/administration/infos-experts'
                },
                {
                    label: 'general.expertSansMandat',
                    url: '/administration/infos-expert-sans-mandat'
                }
            ]
        },
        {
            label: 'menu.candidatures',
            icon: 'folder_shared',
            children: [
                {
                    label: 'front.menuAdmin.group3',
                    url: '/datavis/candidatures-stats'
                },
                {
                    label: 'menu.listeDesDossiers',
                    url: '/administration/dossiers/liste'
                },
                {
                    label: 'menu.dossierDetaille',
                    url: '/dossiers/mes-expertises-reunion-datavis'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group4.label',
            icon: 'folder_special',
            children: [
                {
                    label: 'menu.nominer-expertiser',
                    url: '/datavis/nommer'
                },
                {
                    label: 'front.expertises.experts.title',
                    url: '/datavis/experts'
                },
                {
                    label: 'Expertises DATAVIS',
                    url: '/dossiers/mes-expertises'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group5',
            icon: 'announcement',
            children: [
                {
                    label: 'general.listeDesDecisions',
                    url: '/administration/dossiers/decision'
                },
                {
                    label: 'menu.decisionsAAP',
                    url: '/datavis/decisions-list'
                }
            ]
        },
        {
            label: 'front.menuAdmin.group6',
            icon: 'print',
            children: [
                {
                    label: 'general.etats',
                    url: '/exports/etats'
                },
                {
                    label: 'general.exports',
                    url: '/exports'
                },
                {
                    label: 'general.exportsParAAP',
                    url: '/exports/parAAP'
                },
                {
                    label: 'Export des fichiers',
                    url: '/exports/fichiers'
                }
            ]
        }
    ],
    classKey: 'datavis'
};
